// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Progress Bar */
:host {
  width: 100%;
}

.ids-progress-bar {
  contain: content;
}
.ids-progress-bar .progress-label {
  color: var(--ids-color-neutral-100);
}
.ids-progress-bar .progress-bar {
  background-color: var(--ids-progress-bar-color-background-default);
  border-radius: var(--ids-progress-bar-border-radius);
  border: 1px solid var(--ids-color-border-strong);
  height: var(--ids-progress-bar-height);
  margin: var(--ids-progress-bar-margin);
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}
.ids-progress-bar .progress-bar::-webkit-progress-bar {
  background-color: var(--ids-progress-bar-color-background-default);
  border-radius: var(--ids-progress-bar-border-radius);
}
.ids-progress-bar .progress-bar::-webkit-progress-value {
  background-color: var(--ids-progress-bar-fill-color-background);
  border-radius: var(--ids-progress-bar-border-radius);
  transition: width var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-progress-bar .progress-bar::-moz-progress-bar {
  background-color: var(--ids-progress-bar-fill-color-background);
  border-radius: var(--ids-progress-bar-border-radius);
  transition: width var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-progress-bar.label-audible .progress-bar {
  margin: var(--ids-progress-bar-label-audible-margin);
}
.ids-progress-bar.disabled .progress-label {
  color: var(--ids-progress-bar-color-text-disabled);
}
.ids-progress-bar.disabled .progress-bar {
  border-color: var(--ids-progress-bar-color-background-disabled);
}
.ids-progress-bar.disabled .progress-bar::-webkit-progress-value {
  background-color: var(--ids-progress-bar-color-background-disabled);
  border-color: var(--ids-progress-bar-color-background-disabled);
}
.ids-progress-bar.disabled .progress-bar::-moz-progress-bar {
  background-color: var(--ids-progress-bar-color-background-disabled);
  border-color: var(--ids-progress-bar-color-background-disabled);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-progress-bar/ids-progress-bar.scss"],"names":[],"mappings":"AAAA,qBAAA;AAQA;EACE,WAAA;AANF;;AASA;EACE,gBAAA;AANF;AAQE;EACE,mCAAA;AANJ;AASE;EACE,kEAAA;EACA,oDAAA;EACA,gDAAA;EACA,sCAAA;EACA,sCAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AAPJ;AASI;EACE,kEAAA;EACA,oDAAA;AAPN;AAUI;EA/BF,+DAAA;EACA,oDAAA;EACA,mEAAA;AAwBF;AASI;EAnCF,+DAAA;EACA,oDAAA;EACA,mEAAA;AA6BF;AAUI;EACE,oDAAA;AARN;AAaI;EACE,kDAAA;AAXN;AAcI;EACE,+DAAA;AAZN;AAcM;EACE,mEAAA;EACA,+DAAA;AAZR;AAeM;EACA,mEAAA;EACA,+DAAA;AAbN","sourcesContent":["/* Ids Progress Bar */\n// Mixin progress bar fill area\n@mixin progress-bar-fill {\n  background-color: var(--ids-progress-bar-fill-color-background);\n  border-radius: var(--ids-progress-bar-border-radius);\n  transition: width var(--ids-motion-duration) var(--ids-motion-ease);\n}\n\n:host {\n  width: 100%;\n}\n\n.ids-progress-bar {\n  contain: content;\n\n  .progress-label {\n    color: var(--ids-color-neutral-100);\n  }\n\n  .progress-bar {\n    background-color: var(--ids-progress-bar-color-background-default);\n    border-radius: var(--ids-progress-bar-border-radius);\n    border: 1px solid var(--ids-color-border-strong);\n    height: var(--ids-progress-bar-height);\n    margin: var(--ids-progress-bar-margin);\n    width: 100%;\n    overflow: hidden;\n    box-sizing: border-box;\n\n    &::-webkit-progress-bar {\n      background-color: var(--ids-progress-bar-color-background-default);\n      border-radius: var(--ids-progress-bar-border-radius);\n    }\n\n    &::-webkit-progress-value {\n      @include progress-bar-fill();\n    }\n\n    &::-moz-progress-bar {\n      @include progress-bar-fill();\n    }\n  }\n\n  &.label-audible {\n    .progress-bar {\n      margin: var(--ids-progress-bar-label-audible-margin);\n    }\n  }\n\n  &.disabled {\n    .progress-label {\n      color: var(--ids-progress-bar-color-text-disabled);\n    }\n\n    .progress-bar {\n      border-color: var(--ids-progress-bar-color-background-disabled);\n\n      &::-webkit-progress-value {\n        background-color: var(--ids-progress-bar-color-background-disabled);\n        border-color: var(--ids-progress-bar-color-background-disabled);\n      }\n      \n      &::-moz-progress-bar {\n      background-color: var(--ids-progress-bar-color-background-disabled);\n      border-color: var(--ids-progress-bar-color-background-disabled);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
